import { TrackByFunction } from '@angular/core';

export const trackItemByIndex: TrackByFunction<any> = index => index;
export const trackItemById = trackByProperty('id');

export function trackByProperty<T>(property: keyof T): TrackByFunction<T> {
  return (index: number, item: T) => item[property];
}
